export default __webpack_public_path__ + "static/media/placeholder.65582a57.svg";